export default {
    data() {
        return {
            timerId: 0
        }
    },
    mounted() {
        // get initial size
        this.getSize()

        // add listener for future changes
        addEventListener('resize', this.resizeHandler)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler)
    },
    methods: {
        // only update size when the user has stopped resizing
        resizeHandler() {
            clearTimeout(this.timerId)
            this.timerId = setTimeout(() => this.getSize(), 200)
        },
        getSize() {
            let width = innerWidth
            let height = innerHeight
            this.$store.commit('setSize', { width, height })
        }
    }
}
